import { ProjectSyncState } from 'src/modules/project-sync/types/ProjectSyncState';
import { RootState } from 'src/types/RootState';

export function getProjectSyncState(state: RootState): ProjectSyncState {
  return state.projectSync;
}
